import React, { useCallback, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { HiLockClosed, HiUser } from 'react-icons/hi';

type LoginProps = {
    id: string;
    password: string;
}

const Login = () => {

    const [datas, setDatas] = useState<LoginProps>({ id: '', password: '' });

    const sendDatas = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(datas),
        })
        .then((res) => res.json())
        .then((data) => {
            if (data.statusCode === 500) {
                toast.error("Identifiant ou mot de passe incorrect");
            }
        })
    }, [datas]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-indigo-50 to-purple-50 px-4">
            <ToastContainer />
            
            <div className="w-full max-w-md animate-scaleIn">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-2xl shadow-xl shadow-indigo-200 mb-4">
                        <img className="w-16 h-16" src="/logo192.png" alt="logo" />
                    </div>
                    <h1 className="text-2xl font-bold text-slate-800">Amicale des Sapeurs-Pompiers</h1>
                    <p className="text-slate-500 mt-1">Connectez-vous à votre espace</p>
                </div>

                {/* Login Card */}
                <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 overflow-hidden">
                    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4">
                        <h2 className="text-xl font-bold text-white text-center">Connexion</h2>
                    </div>
                    
                    <form className="p-6 space-y-5" onSubmit={sendDatas}>
                        <div>
                            <label className="block mb-2 text-sm font-semibold text-slate-700">Identifiant</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <HiUser className="w-5 h-5 text-slate-400" />
                                </div>
                                <input 
                                    type="text"
                                    onChange={(e) => {setDatas({...datas, id: e.target.value})}} 
                                    className="input-modern pl-10" 
                                    placeholder="Entrez votre identifiant" 
                                />
                            </div>
                        </div>
                        
                        <div>
                            <label className="block mb-2 text-sm font-semibold text-slate-700">Mot de passe</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <HiLockClosed className="w-5 h-5 text-slate-400" />
                                </div>
                                <input 
                                    onChange={(e) => {setDatas({...datas, password: e.target.value})}} 
                                    type="password" 
                                    name="password" 
                                    id="password" 
                                    placeholder="••••••••" 
                                    className="input-modern pl-10" 
                                />
                            </div>
                        </div>
                        
                        <button 
                            type="submit" 
                            className="btn-primary w-full py-3 text-base font-semibold"
                        >
                            Se connecter
                        </button>
                    </form>
                </div>

                <p className="text-center text-sm text-slate-500 mt-6">
                    © 2024 Amicale des Sapeurs-Pompiers
                </p>
            </div>
        </div>
    )
}

export default Login